import type { FC } from 'react'
import type { ICmsSteps } from '@/pages/tad.ai/_components/FeatureCms/_types'

import { H2 } from '@/pages/tad.ai/_components/H2'
import { PrimaryButton } from '@/pages/tad.ai/_components/PrimaryButton'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface IStepsProps {
  steps?: ICmsSteps | null
  className?: string
}

export const Steps: FC<IStepsProps> = (props) => {
  const { steps, className } = props || {}
  if (!steps) {
    return null
  }
  const { list = [], title, btnHref, btnText } = steps

  return (
    <div className={cls`flex flex-col ${className}`}>
      {/* 上：标题居中 */}
      <div className='flex justify-center'>
        <H2>{title}</H2>
      </div>

      {/* 中：列表横向排列（小屏竖向豆腐块） */}
      <div className='flex flex-col gap-4 pt-4 md:flex-row md:gap-6 md:pt-8'>
        {list.map((item, index) => (
          <div
            key={index}
            className='border-f-border flex flex-1 flex-col gap-3 rounded-xl border bg-[#1a1a1a]/50 p-4 md:p-6'
          >
            <span className='text-f-primary text-4xl font-[100px] md:text-[56px]'>
              0{index + 1}
            </span>
            <p className='text-f-other-10 text-sm md:text-base'>
              {item.stepTitle}
            </p>
            {item.stepDesc && (
              <RichTextElement
                as='p'
                html={item.stepDesc}
                className='text-f-text-secondary text-xs md:text-sm'
              />
            )}
          </div>
        ))}
      </div>

      {/* 下：按钮居中 */}
      {btnText && btnHref && (
        <div className='flex justify-center pt-8 md:pt-12'>
          <PrimaryButton href={btnHref} className='mx-auto'>
            {btnText}
          </PrimaryButton>
        </div>
      )}
    </div>
  )
}
